/**
 * The orientation along which the elements are laid out.
 */
export var StackOrientation = {
  Horizontal: 'horizontal',
  Vertical: 'vertical'
};